import { styled, checkboxClasses, svgIconClasses, formControlLabelClasses } from "@mui/material";
import { FormControlLabel as FormControlLabel$1 } from "../../utils/shared/FormControlLabel.js";
import { FieldHelperText as FieldHelperText$1 } from "../field-helper-text/field-helper-text.js";
import "react/jsx-runtime";
import "react";
import "react-i18next";
import "../../utils/yup/main.js";
import "yup";
import "../../utils/fields/personalInformation.js";
import "../../../../../type/Appointment.js";
import "../masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../utils/entities/Form.js";
import "../../../ana-toolbox/ana-toolbox.js";
import "../../../../../constants/date/date.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "date-fns";
import "../../utils/helpers/toBoolean.js";
import "../../utils/helpers/createFields.js";
import "../../utils/helpers/resetFields.js";
import "../../utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../utils/helpers/predicates.js";
import "../../utils/yup/emailValidation.js";
import "../../utils/fields/contactDetails.js";
import "../../utils/helpers/featureFlags.js";
import "../../utils/helpers/getAgeFromBirthday.js";
import "../../utils/yup/buildValidationSchema.js";
import "../../utils/fields/miscellaneous.js";
import "../../utils/fields/insurance.js";
import "../../utils/fields/allergiesAndMedications.js";
import "../../../../../type/Disease.js";
import "../../utils/config/medicaments.js";
import "../../utils/fields/wishesAndExpectations.js";
import "../../utils/fields/consents.js";
import "../../utils/fields/profileInterest.js";
import "../translate/translate.js";
const FormControlLabel = styled(FormControlLabel$1)(({ theme, error }) => ({
  justifyContent: "flex-start",
  alignItems: "flex-start",
  [`& .${checkboxClasses.root}`]: {
    marginTop: 3,
    [`& .${svgIconClasses.root}`]: {
      color: error ? theme.palette.error[500] : "inherit"
    }
  },
  [`.${formControlLabelClasses.label}`]: {
    ...theme.typography["Lato Body 2"]
  },
  a: {
    color: theme.palette.primary.main
  }
}));
const FieldHelperText = styled(FieldHelperText$1)(({ theme }) => ({
  marginLeft: theme.spacing(5),
  marginTop: theme.spacing(1)
}));
export {
  FieldHelperText,
  FormControlLabel
};
